import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Backdrop, Box, Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, Grid,
  Typography
} from '@material-ui/core';
import CreateAutomationFilters from './create_automation/Filters';
import CreateAutomationSchedule from './create_automation/Schedule';
import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router';
import Alert from './Alert';
import CreateAutomationTextAndScreen from './create_automation/TextAndScreen';

const CreateAutomationPushes = observer(({ automationStore }) => {
  const navigate = useNavigate();

  const setAccordion = (step) => {
    automationStore.setCurrentStep(step);
  }

  const DownloadReport = (
    <a onClick={e => automationStore.downloadReport()}>
      (clique aqui para exportar)
    </a>
  );

  return (<div>
      <Accordion disableGutters expanded={automationStore.getCurrentStep === 'filters'} onClick={e => {
        e.preventDefault();
        setAccordion('filters');
      }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='filters'>
          <Typography><b>Parte 1 - Filtros</b>
            <i>{automationStore.filtersQty === 0 ? 'Nenhum filtro aplicado' : `${automationStore.filtersQty} filtros aplicadoss`}</i></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CreateAutomationFilters automationStore={automationStore} />
        </AccordionDetails>
      </Accordion>
      <Accordion disableGutters expanded={automationStore.getCurrentStep === 'results'}>
        <AccordionSummary
          aria-controls='panel1a-content'
          id='results'>
          <Typography>
            <b>Parte 2 - Resultados</b>
            {automationStore.selectedUsersCount === 0 ?
              <i>'Nenhum usuário selecionado'</i> :
              <i>{`${automationStore.selectedUsersCount} usuários selecionados`} <a onClick={e => automationStore.downloadReport()}>
                (clique aqui para exportar)
              </a></i>
            }
          </Typography>
        </AccordionSummary>
      </Accordion>
      <Accordion disableGutters expanded={automationStore.getCurrentStep === 'actions'}
                 onClick={e => {
                   e.preventDefault();
                   setAccordion('actions');
                 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='actions'>
          <Typography><b>Parte 3 - Textos e tela destino</b> <i>{automationStore.actionsQty === 0 ? 'Nenhuma ação definida' : `${automationStore.actionsQty} ações definidas`}</i></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CreateAutomationTextAndScreen automationStore={automationStore} />
        </AccordionDetails>
      </Accordion>
      {automationStore.getCurrentStep === 'schedule' && <Grid container spacing={4} justifyContent='flex-end'>
        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant='contained' onClick={async (e) => {
              await automationStore.sendPushes();
            }}>Executar</Button>
          </Box>
        </Grid>
      </Grid>}
      {automationStore.loading && <Backdrop open={automationStore.loading}><CircularProgress /></Backdrop>}
      <Alert automationStore={ automationStore } />
      <Dialog
        open={automationStore.currentStep === 'finish'}
        onClose={e => navigate('/app')}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Ações iniciadas</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            você pode sair dessa página
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={e => navigate('/app/automation')} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default CreateAutomationPushes;
